import { createAction, props } from '@ngrx/store'
import { SoughtPartnerTableItem } from '../../../features/feature-edit-project/models/sought-partner-dialog-table.interface'
import { ProjectBodyRequest } from '../../../features/feature-edit-project/models/project-body-request.interface'
import { HttpErrorResponse } from '@angular/common/http'

export const addSoughtPartner = createAction('[edit-project] Add sought partner', props<{ body: SoughtPartnerTableItem }>())

export const replaceSoughtPartner = createAction('[edit-project] Replace sought partner', props<{ id: number; body: SoughtPartnerTableItem }>())

export const removeSoughtPartner = createAction('[edit-project] Remove sought partner', props<{ id: number }>())

export const cleanSoughtPartnerTable = createAction('[edit-project] Cleaning sought partner data')

export const createProject = createAction('[edit-project] Creating project', props<{ body: ProjectBodyRequest }>())

export const createProjectSuccess = createAction('[edit-project] Creating project SUCCESS', props<{ id: number; status: number }>())

export const createProjectFailure = createAction('[edit-project] Creating project FAILURE', props<{ error: HttpErrorResponse }>())

export const createDraft = createAction('[edit-project] Creating draft', props<{ body: ProjectBodyRequest }>())

export const createDraftSuccess = createAction('[edit-project] Creating draft SUCCESS', props<{ id: number; status: number }>())

export const createDraftFailure = createAction('[edit-project] Creating draft FAILURE', props<{ error: HttpErrorResponse }>())

export const initSoughtPartnerTable = createAction('[edit-project] Initing sought partner for edit', props<{ body: SoughtPartnerTableItem[] }>())

export const editProject = createAction('[edit-project] Editing project...', props<{ id: number; body: ProjectBodyRequest }>())

export const editProjectSuccess = createAction('[edit-project] Editing project SUCCESS', props<{ id: number; status: number }>())

export const editProjectFailure = createAction('[edit-project] Editing project FAILURE', props<{ error: HttpErrorResponse }>())

export const editDraft = createAction('[edit-project] Editing draft...', props<{ id: number; body: ProjectBodyRequest }>())

export const editDraftSuccess = createAction('[edit-project] Editing draft SUCCESS', props<{ id: number; status: number }>())

export const editDraftFailure = createAction('[edit-project] Editing draft FAILURE', props<{ error: HttpErrorResponse }>())
